import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    none: translate({ id: 'global.none' }),
    requiredVehicle: translate({ id: 'order.form.single.field.forceVehicleId.label' }),
  }))

  return api
}
